import { Check } from "lucide-react";
import { formatMoney } from "../../utils/formatMoney";

export default function InsuranceCard({ item, onClick, showCompareOption = false, isSelected = false, onToggleSelect }) {
  const UNIFIED_CARD_STYLES = {
    card: "bg-gradient-to-br from-emerald-50 to-green-50 border-emerald-200 hover:border-emerald-400",
    header: "bg-gradient-to-r from-emerald-100 to-green-100",
    price: "text-emerald-700",
    policyBadge: "bg-emerald-100 text-emerald-800 ring-emerald-200",
    button: "bg-emerald-600 hover:bg-emerald-700",
  };

  const styles = UNIFIED_CARD_STYLES;

  const handleCardClick = (e) => {
    e.stopPropagation();
    if (showCompareOption && onToggleSelect) {
      // In compare mode, toggle selection
      onToggleSelect(item);
    } else if (onClick) {
      // Normal mode: open details
      onClick();
    }
  };

  return (
    <div
      onClick={showCompareOption && onToggleSelect ? () => onToggleSelect(item) : undefined}
      className={`group relative rounded-xl sm:rounded-2xl border shadow-sm hover:shadow-xl transition-all duration-300 overflow-hidden h-full flex flex-col ${
        isSelected ? "ring-2 ring-emerald-500 ring-offset-2" : ""
      } ${showCompareOption ? "cursor-pointer" : ""} ${styles.card}`}
    >
      {/* Comparison Checkbox */}
      {showCompareOption && (
        <div className="absolute top-2 right-2 z-10">
          <button
            data-compare-btn
            onClick={(e) => {
              e.stopPropagation();
              if (onToggleSelect) {
                onToggleSelect(item);
              }
            }}
            className={`flex items-center justify-center w-6 h-6 rounded-full border-2 transition-all ${
              isSelected
                ? "text-white bg-emerald-500 border-emerald-500"
                : "bg-white border-gray-300 hover:border-emerald-400"
            }`}
          >
            {isSelected && <Check size={14} />}
          </button>
        </div>
      )}
      <div className={`flex items-center justify-center pt-3 pb-2 sm:pt-4 sm:pb-3 ${styles.header}`}>
        <img
          src={item.companyLogo}
          alt="TripSecure Insurance"
          className="object-contain w-20 h-16 sm:w-24 md:w-28"
        />
      </div>

      <div className="flex-1 px-4 py-3 sm:px-6">
        <div className="mb-4 text-center sm:mb-5">
          <h3 className="mb-1 text-base font-bold leading-tight text-gray-900 truncate sm:line-clamp-2 sm:text-lg md:text-xl">
            {item.policyName}
          </h3>
          <p className="text-xs text-gray-500 sm:text-sm">
            {item.provider}
          </p>
        </div>

        <div className="flex justify-center mb-4 sm:mb-5">
          <span
            className={`inline-flex items-center px-4 py-2 text-xs sm:text-sm font-semibold rounded-lg ring-1 ${styles.policyBadge}`}
          >
            {item.policy_type === "okada_rider" ? "Motor Rider" :
            item.policy_type?.replace("_", " ").replace(/\b\w/g, (l) => l.toUpperCase()) || "Insurance"}
          </span>
        </div>

        <div className="mb-4 text-center sm:mb-5">
          <div className="flex gap-2 justify-center items-baseline mb-2">
            <span
              className={`text-lg sm:text-2xl md:text-3xl font-bold ${styles.price}`}
            >
              {formatMoney(item.premiumMin || 0)}
            </span>
            {item.premiumMax > item.premiumMin && (
              <>
                <span className="text-lg text-gray-500 sm:text-xl">-</span>
                <span
                  className={`text-lg sm:text-2xl md:text-3xl font-bold ${styles.price}`}
                >
                  {formatMoney(item.premiumMax || 0)}
                </span>
              </>
            )}
          </div>
        </div>
      </div>

      <div className="px-4 pb-5 sm:px-6 sm:pb-6">
        <button
          onClick={handleCardClick}
          className={`w-full px-6 py-3 text-xs sm:text-base font-semibold text-white rounded-lg transition-all duration-200 ${styles.button} hover:shadow-lg`}
        >
          {showCompareOption ? (isSelected ? "Selected" : "Select to Compare") : "View Details"}
        </button>
      </div>
    </div>
  );
}

